/* unplugin-vue-components disabled */import { render } from "./TicketsEmails.vue?vue&type=template&id=31724bf6&ts=true"
import script from "./TicketsEmails.vue?vue&type=script&lang=ts"
export * from "./TicketsEmails.vue?vue&type=script&lang=ts"

import "./TicketsEmails.vue?vue&type=style&index=0&id=31724bf6&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__